import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepConnector from '@material-ui/core/StepConnector';
import StepLabel from '@material-ui/core/StepLabel';

const styles = theme => ({
    connector: { flex: 0.1 },
    horizontal: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '1px 1px 1px rgba(0,0,0,0.2)',
    },
});

export default withStyles(styles)(({ classes, active, labels }) => (
    <Stepper
        activeStep={active}
        classes={{
            horizontal: classes.horizontal,
        }}
        connector={<StepConnector className={classes.connector} />}
    >
        {labels.map(label => {
            return (
                <Step key={label}>
                    <StepLabel>{label}</StepLabel>
                </Step>
            );
        })}
    </Stepper>
));
